import React, { Component } from 'react';

class Error extends Component {

  render() {
    return (
        <div className="page error" id="page">
          Achcho, we don't have that page!<br /><br />
          <a href="/">Go Home!</a>
        </div>
    );
  }
}

export default Error;



// WEBPACK FOOTER //
// ./src/page/Error.js